import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import VendorRegistration from "./pages/VendorRegistration";
import VendorSignIn from "./pages/VendorSignIn";
import VendorForgotPassword from "./pages/VendorForgotPassword";
import { Toaster } from 'react-hot-toast';
import { persistor, store } from "./store/store";
import { Provider, useDispatch, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import AuthWrapper from "./components/AuthWrapper";
import { getProfile, selectAuth } from "./store/slices/authSlice";
import VendorOnboarding from "./pages/VendorOnboarding";
import VendorDashboard from "./components/vendor/VendorDashboard";
import { Skeleton } from "./components/UI/Skeleton";

// ✅ Moved outside App — prevents recreation on every render
const LoadingSpinner = () => (
  <div className="flex min-h-screen items-center justify-center bg-white p-6">
    <div className="w-full max-w-md space-y-5" role="status" aria-busy="true" aria-label="Loading">
      <Skeleton className="h-8 w-48" />
      <Skeleton className="h-4 w-64" />
      <Skeleton className="h-12 w-full rounded-xl" />
      <Skeleton className="h-12 w-full rounded-xl" />
      <Skeleton className="h-12 w-full rounded-xl" />
    </div>
  </div>
);

// ✅ Moved outside App — prevents recreation on every render
const AppInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const { accessToken, isAuthenticated } = useSelector(selectAuth);

  useEffect(() => {
    if (accessToken && !isAuthenticated) {
      dispatch(getProfile());
    }
  }, [accessToken, isAuthenticated, dispatch]);

  return <>{children}</>;
};

function App() {
  return (
    <Provider store={store}>
      <Toaster />
      <PersistGate loading={<LoadingSpinner />} persistor={persistor}>
        <AppInitializer>
          <Router>
            <div className="min-h-screen flex flex-col bg-gray-50">
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/vendor-registration" element={<VendorRegistration />} />
                  <Route path="/vendor-signin" element={<VendorSignIn />} />
                  <Route path="/vendor-forgot-password" element={<VendorForgotPassword />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route path="/terms" element={<TermsOfService />} />
                  <Route
                    path="/dashboard"
                    element={
                      <AuthWrapper>
                        <VendorDashboard />
                      </AuthWrapper>
                    }
                  />
                  <Route
                    path="/onboarding"
                    element={
                      <AuthWrapper>
                        <VendorOnboarding />
                      </AuthWrapper>
                    }
                  />
                </Routes>
              </main>
            </div>
          </Router>
        </AppInitializer>
      </PersistGate>
    </Provider>
  );
}

export default App;